import React, { createContext, useState, useContext, useEffect } from "react";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
    const [state, setState] = useState({
        view: "external",
        selectedInternalColourType: "standard",
        selectedInternalSlabColourType: "standard",
        selectedExternalColourType: "standard",
        selectedExternalFrameColourType: "standard",
        selectedExternalSlabColourType: "standard",
        sidebarOpen: true,
        // TODO
        currentPage: "home",
        viewChangeLoading: false,
        isOxide:false
    });
    const [csrfToken, setCsrfToken] = useState("");

    useEffect(() => {
        const token = document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute("content");
        setCsrfToken(token);
    }, []);

    const setViewLoading = (val) => {
        setState((prevState) => ({
            ...prevState,
            viewChangeLoading: val,
        }));
    };

    const setIsOxide = (val) => {
        setState((prevState) => ({
            ...prevState,
            isOxide: val,
        }));
    }

    const setView = (view) => {
        setViewLoading(true);
        setState((prevState) => ({
            ...prevState,
            view,
        }));
    };

    const setCurrentPage = (page) => {
        setState((prevState) => ({
            ...prevState,
            currentPage: page,
        }));
    };

    const setSidebarOpen = () => {
        setState((prevState) => ({
            ...prevState,
            sidebarOpen: !prevState.sidebarOpen,
        }));
    };

    const setSelectedInternalColourType = (selectedInternalColourType) => {
        setState((prevState) => ({
            ...prevState,
            selectedInternalColourType,
        }));
    };

    const setSelectedInternalSlabColourType = (selectedInternalSlabColourType) => {
        setState((prevState) => ({
            ...prevState,
            selectedInternalSlabColourType,
        }));
    };

    const setSelectedExternallColourType = (selectedExternalColourType) => {
        setState((prevState) => ({
            ...prevState,
            selectedExternalColourType,
        }));
    };

    const setSelectedExternalFrameColourType = (selectedExternalFrameColourType) => {
        setState((prevState) => ({
            ...prevState,
            selectedExternalFrameColourType,
        }));
    };

    const setSelectedExternalSlabColourType = (selectedExternalSlabColourType) => {
        setState((prevState) => ({
            ...prevState,
            selectedExternalSlabColourType,
        }));
    };

    return (
        <AppContext.Provider
            value={{
                state,
                setView,
                setSelectedInternalColourType,
                setSelectedInternalSlabColourType,
                setSelectedExternallColourType,
                setSelectedExternalFrameColourType,
                setSelectedExternalSlabColourType,
                setSidebarOpen,
                setCurrentPage,
                setViewLoading,
                csrfToken,
                setIsOxide,
            }}
        >
            {children}
        </AppContext.Provider>
    );
};

// Create a custom hook for easier usage
export const useAppContext = () => {
    return useContext(AppContext);
};
